<ng-template #createMultipleBorrowers>
  @if (inEditMode) {
    <div class="d-flex mb-2">
      <label class="fs-6 col-sm-4 col-form-label fw-bold fs-6 editor-label">Restrict Middle Name/Initial to Single Character:</label>
      <div class="col-sm-2 form-check form-switch form-check-custom form-check-solid" style="margin-top: 8px;">
        <input class="form-check-input h-20px w-30px" type="checkbox" id="restrictMiddleNameToSingleCharacter"
          [ngModelOptions]="{standalone: true}" [(ngModel)]="step.restrictMiddleNameToSingleCharacter" />
        <label class="form-check-label" for="restrictMiddleNameToSingleCharacter">
          {{step.restrictMiddleNameToSingleCharacter ? "Yes" : "No"}}
        </label>
      </div>
    </div>
    <div class="d-flex mb-2">
      <label class="fs-6 col-sm-4 col-form-label fw-bold fs-6 editor-label">Force Co-borrowers into same application:</label>
      <div class="col-sm-2 form-check form-switch form-check-custom form-check-solid" style="margin-top: 8px;">
        <input class="form-check-input h-20px w-30px" type="checkbox" id="forceCoborrowersIntoSameApplication"
          [ngModelOptions]="{standalone: true}" [(ngModel)]="step.forceCoborrowersIntoSameApplication" />
        <label class="form-check-label" for="forceCoborrowersIntoSameApplication">
          {{step.forceCoborrowersIntoSameApplication ? "Yes" : "No"}}
        </label>
      </div>
    </div>
    @if (canConfigureCoBorrowerPersonalInfo) {
      <div class="d-flex mb-2">
        <label class="fs-6 col-sm-4 col-form-label fw-bold fs-6 editor-label">Allow Borrower Enter Co-Borrower Personal Information:</label>
        <div class="col-sm-2 form-check form-switch form-check-custom form-check-solid" style="margin-top: 8px;">
          <input class="form-check-input h-20px w-30px" type="checkbox" id="allowBorrowerEnterCoBorrowerPersonalInformation"
            [ngModelOptions]="{standalone: true}" [(ngModel)]="allowBorrowerEnterCoBorrowerPersonalInformation" />
          <label class="form-check-label" for="allowBorrowerEnterCoBorrowerPersonalInformation">
            {{allowBorrowerEnterCoBorrowerPersonalInformation ? "Yes" : "No"}}
          </label>
        </div>
      </div>
    }
  }
  <div class="row mb-10">
    @for (coBorrower of coBorrowers; track coBorrower.borrowerId; let i = $index) {
      <div class="col-md-12 fv-row mb-5">
        <div class="card card-flush shadow-sm">
          <div class="card-header mh-30">
            <h3 class="card-title">{{coBorrower.firstName + " " + coBorrower.lastName}}</h3>
          </div>
          <div class="card-body py-2">
            <borrower-info-mini
              #borrowerInfo
              [borrower]="coBorrower"
              [fieldsToConfig]="step.fieldConfig"
              [restrictMiddleNameToSingleCharacter]="step.restrictMiddleNameToSingleCharacter"
              [allowBorrowerEnterCoBorrowerPersonalInformation]="effectiveAllowBorrowerEnterCoBorrowerPersonalInformation"
              [borrowerSettings]="borrowerSettings"
              (borrowerMarkedAsMarriedToPrimaryBorrower)="onBorrowerMarkedAsMarriedToPrimaryBorrower($event)">
            </borrower-info-mini>
          </div>
        </div>
      </div>
    }
  </div>
</ng-template>

<wizard-step-template [stepMainTemplate]="createMultipleBorrowers" [step]="step"
  [stepComponent]="this"></wizard-step-template>
